import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import FontIcon from 'material-ui/FontIcon';
import 'flexboxgrid/css/flexboxgrid.min.css'
import './Playlist.css'
import Button from '../../../../components/Button'

class Playlists extends Component {

    constructor(props) {
        super(props)
        this.state = {
            playlists: { objects: [] }
        }
    }

    findPublicPlaylists = async () => {
        let request = await fetch(`https://papirodev.appspot.com/_ah/api/public/v1/playlists`)
        let playlists = await request.json()
        this.props.device.playlists = playlists
        this.setState({ playlists: playlists })
    }

    componentDidMount = () => {
        this.findPublicPlaylists()
    }

    findPos = (obj) => {
        var curtop = 0;
        if (obj.offsetParent) {
            do {
                curtop += obj.offsetTop;
            } while (obj = obj.offsetParent);
            return [curtop];
        }
    }


    selectPlaylist = (playlist) => {
        playlist.selected = !playlist.selected
        window.ga('send', { hitType: 'event', eventCategory: "freemium", eventAction: 'playlist-selected', eventLabel: playlist.name });
        this.setState(prevState => (
            { playlists: prevState.playlists }
        ))
        this.props.playlistsChangedListener();
    }

    render() {
        return (
            <section className="playlists" id="section-playlist">
                <div className="row">
                    {this.state.playlists.objects.map((object, index) =>
                        <div key={'div_'.concat(object.dbid.id)} className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <Button onClick={() => this.selectPlaylist(object)} selected={object.selected}>
                                {object.name} {object.selected && <FontIcon className="fa fa-check"></FontIcon>}
                            </Button>
                        </div>
                    )}
                </div>
            </section>
        );
    }
}

export default Playlists;


// WEBPACK FOOTER //
// ./src/pages/home/sections/playlists/Playlists.js